import React from 'react';
import { NameMobileInputs } from '../../../domain/order/Item/OrderInfoInput';
import { MYPAGE_ORDER_MENU } from '../../../lib/routes/MyPageRoutes';

import { Text } from '../atom/Text';
import { TextareaWithCounter } from '../molecules/TextareaWithCounter';
import { Layout, OrderTemplate } from './OrderTemplate';

const PresentTemplate = ({
  onChange,
  onSubmit,
  finalPrice,
  defaultPrice,
  finalShippingFee,
  name,
  mobile,
  recipientMessage,
  onPayMethod,
  pg,
  pay_method,
  onSelectVoucherCoupon,
}) => (
  <OrderTemplate
    onChange={onChange}
    onCheck={onSubmit}
    onPayMethod={onPayMethod}
    pg={pg}
    pay_method={pay_method}
    finalPrice={finalPrice}
    discountPrice={defaultPrice - (finalPrice - finalShippingFee)}
    finalShippingFee={finalShippingFee}
    defaultPrice={defaultPrice}
    onSelectVoucherCoupon={onSelectVoucherCoupon}
    couponOnly={true}
  >
    <Layout title="2. 보내는 분" required>
      <NameMobileInputs onChange={onChange} state={{ name, mobile }} />
    </Layout>
    <Layout title="3. 받으실 분" required>
      <NameMobileInputs onChange={onChange} formData={ORDER_INFO_DATA} />
      <Text color="orangePink" size={12}>
        * 받는 분의 주소, 입체 초음파 사진, 아기에게 보내는 메시지는
        베이비페이스가 여쭤볼게요.
      </Text>
      <Text color="brownGrey" size={12}>
        - 수령인 연락처로 배송지와 사진을 업로드 할 수 있는 URL이 발송됩니다.
      </Text>
      <Text color="brownGrey" size={12}>
        - 오류로 인해 문자가 가지 않는다면 [{MYPAGE_ORDER_MENU.label}]에서 [다시
        전송] 버튼을 눌러 주세요.
      </Text>
    </Layout>
    <Layout title="4. 선물 메시지">
      <TextareaWithCounter
        placeholder={`[${name}님께서 남기신 메시지]\n\n여기에 작성하신 메시지가 문자메시지에 함께 전달됩니다.\n이모지를 제외한 글자 수 200자 미만으로 입력해주세요`}
        type="text"
        name="recipientMessage"
        value={recipientMessage}
        onChange={onChange}
        maxLength={200}
      />
    </Layout>
  </OrderTemplate>
);

export default PresentTemplate;

const ORDER_INFO_DATA = [
  {
    mainIconName: 'person',
    placeholder: '예) 베이비페이스',
    type: 'text',
    name: 'recipientName',
  },
  {
    mainIconName: 'smartphone',
    placeholder: '예) 01012345678',
    type: 'number',
    name: 'recipientMobile',
  },
];
